import { ResponsiveContainer, LineChart, Line, XAxis, YAxis, Tooltip, CartesianGrid } from 'recharts';
import { ChartCard, ChartEmpty } from './ChartCard';

interface Point { time: string; price: number; }
interface Props {
  usdkrw: Point[];
  /** legacy — 사용 안 함 (AI 분석은 본문 텍스트 영역으로 이동) */
  fxAnalysis?: string;
}

/** 모닝 브리핑 — 원/달러 환율 단일 차트 (풀폭).
 *  AI 분석 텍스트는 본문 article 의 '원/달러 환율 분석' 섹션으로 이동. */
export function MorningChart({ usdkrw }: Props) {
  return (
    <ChartCard title="원/달러 환율" subtitle="30분봉">
      {usdkrw.length === 0 ? (
        <ChartEmpty />
      ) : (
        <ResponsiveContainer width="100%" height={280}>
          <LineChart data={usdkrw} margin={{ top: 6, right: 12, left: 0, bottom: 0 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="var(--color-border)" />
            <XAxis dataKey="time" tick={{ fontSize: 10 }} interval={Math.ceil(usdkrw.length / 8)} />
            <YAxis
              domain={['dataMin - 1', 'dataMax + 1']}
              tick={{ fontSize: 11 }}
              width={80}
              tickFormatter={(v: number) => `${v.toLocaleString()}원`}
            />
            <Tooltip
              formatter={(v: number) => [`${v.toFixed(2)}원`, '환율']}
              labelFormatter={(label: string) => `시간 ${label}`}
            />
            <Line
              name="환율"
              type="monotone"
              dataKey="price"
              stroke="#16a34a"
              strokeWidth={2}
              dot={false}
            />
          </LineChart>
        </ResponsiveContainer>
      )}
    </ChartCard>
  );
}
